import { tv } from 'tailwind-variants'

export const emptySlotVariants = tv({
  base: 'rounded-xl border-2 border-white/20 flex items-center justify-center opacity-50',
  variants: {
    variant: {
      dashed: 'border-dashed',
      solid: 'border-solid'
    }
  },
  defaultVariants: {
    variant: 'dashed'
  }
})